module.exports = __webpack_public_path__ + "img/8-fourImg.b85b4b20.png";